<template>
  <div :style="divStyle">
    <div
      class="v-input v-input--dense v-input--hide-details v-text-field v-text-field--outlined v-text-field--enclosed"
      style="height: 100%;"
    >
      <div class="v-input__control" style="height: 100%;">
        <div class="v-input__slot"
             style="padding-left: 0; padding-right: 0; margin-bottom: 0; height: 100%;">
          <fieldset style="border-radius: 4px; border-color: rgba(0, 0, 0, 0.45);"
                    aria-hidden="true">
            <legend style="font-size: smaller;">Projects</legend>
          </fieldset>
          <div style="width: 100%; height: 100%; overflow-y: scroll;">
            <template v-for="project in project_items">
              <v-checkbox
                :key="project.id"
                :label="project.name" :value="project.id"
                v-model="inputs.project"
                dense hide-details>
              </v-checkbox>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

	import format from 'string-format'
	import {mapGetters,} from 'vuex'

	export default {
		name: 'project-selector',
		components: {},
		data: function () {
			return {
				inputs: {
					project: [],
				},
			}
		},

		props: {
			value: {type: Array, default: () => [],},
			second: {type: Array, default: () => [],},

			width: {type: String, default: null,},
			height: {type: String, default: null,},
			minWidth: {type: String, default: null,},
			minHeight: {type: String, default: null,},
			maxWidth: {type: String, default: null,},
			maxHeight: {type: String, default: null,},
		},

		watch: {
			value: function () {
				this.inputs.project = this.value
				// console.debug(format(
				// 	"ProjectSelectorComponent.watch.value( {0} )",
				// 	JSON.stringify(this.inputs.project)))
			},

			'inputs.project': function () {
				// console.debug(format(
				// 	"ProjectSelectorComponent.watch.'inputs.project'( {0} )",
				// 	JSON.stringify(this.inputs.project)))
				this.$emit('input', this.inputs.project)
			},
		},

		computed: {
			...mapGetters({
				project_list: 'lists/project_list',
				project_selected: 'project/selected',
			}),

			divStyle: function () {
				const res = {
					width: this.width,
					height: this.height,
					minWidth: this.minWidth,
					minHeight: this.minHeight,
					maxWidth: this.maxWidth,
					maxHeight: this.maxHeight,
				}

				return res
			},

			project_items: function () {
				return this.project_list.filter((p) => p.id > 0)
			},
		},

		created: function () {

		},

		mounted: function () {
			// console.debug(format(
			// 	"ProjectSelectorComponent.mounted()\n" +
			// 	"  {0}",
			// 	JSON.stringify({
			// 		value: this.value,
			// 		second: this.second,
			// 		inputs: this.inputs
			// 	})))

			// маленький костыль для первой отрисовки компонента в диалоге
			this.inputs.project = this.value
		},

		methods: {},
	}
</script>

<style>

  .v-text-field .v-input--checkbox {
    margin-left: 12px;
    /*background-color: lightgoldenrodyellow;*/
  }

  .v-text-field .v-input--checkbox label {
    /*background-color: lightblue;*/
    top: 0 !important;
  }

</style>